export default "__VITE_ASSET__Cm_96yqG__"